/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { VideoTextTemplate } from './videoTextTemplate'

/**
 * @nullable
 */
export type ScenarioVideoWithTemplatesAllOfVideoTextTemplate = VideoTextTemplate | null
